import { RetailCustomer } from "../features/retail/pages/retail-customer"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function RetailCustomerPage() {
  return (
    <DashboardLayout>
      <RetailCustomer />
    </DashboardLayout>
  )
}
